import { ReactTFC } from "../../utils/fp/missing-ts-parts";
import { ImageAndProductType } from "@swo/storefront";
import { FocalPointPosition } from "../_shared-components/image-related/ImageWithFocalPoint";
import { SimpleAspectRatio } from "../_shared-components/SimpleAspectRatio";

import { css } from "@emotion/react";

import { CSS_COLORS } from "../../styles/styles-css-variables";
import React from "react";
import { ImgWithObjectPosition } from "../_shared-components/image-related/ImgWithObjectPosition";

export const ImageAndProductImage: ReactTFC<
  Pick<ImageAndProductType, "image"> & { requestedWidth: number }
> = props => {
  const focalPointObj = FocalPointPosition.create(props.image.image, props.image.focalPoint);

  return (
    <SimpleAspectRatio
      className="u-relative"
      css={css`
        --aspect-ratio: ${focalPointObj.imageInversedAspectRatio()};

        background-color: ${CSS_COLORS.Grey0};

        &:hover ~ div {
          .product-teaser-info {
            span {
              filter: opacity(1) !important;
            }
          }

          .product-card {
            visibility: visible;
            transition: 0.15s linear;
            filter: opacity(1);
          }
        }
      `}
    >
      <ImgWithObjectPosition
        contentfulLink={{ url: props.image.image.url, requestedWidth: props.requestedWidth }}
        alt={props.image.image.description || props.image.image.title}
        focalPointCssStr={focalPointObj.asCssString()}
        assetId={props.image.image.sys.id}
        attachPictureStyles={css`
          display: flex;
          width: 100%;
          height: 100%;
        `}
      />
    </SimpleAspectRatio>
  );
};
